
const m = window.require("discourse/lib/notification-levels");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
